// Endpoint Environments
import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const GraphQLStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}/graphql`,
  [Environment.local]: `http://localhost:${mockServerPort}/graphql`,
  [Environment.development]:
    'https://apollo-gateway.api.trip.dev.moia-group.io/graphql',
  [Environment.integration]:
    'https://apollo-gateway.api.trip.int.moia-group.io/graphql',
  [Environment.production]:
    'https://apollo-gateway.api.trip.prd.moia-group.io/graphql',
}

export const GraphQLEndpoint = GraphQLStages[ENV]

const SubscriptionGatewayStages: Record<Environment, string> = {
  [Environment.test]: `ws://localhost:${mockServerPort}/graphql`,
  [Environment.local]: `ws://localhost:${mockServerPort}/graphql`,
  [Environment.development]: 'wss://subscription-gateway-v2.dev.moia-group.io',
  [Environment.integration]: 'wss://subscription-gateway-v2.int.moia-group.io',
  [Environment.production]: 'wss://subscription-gateway-v2.prd.moia-group.io',
}

export const SubscriptionGatewayEndpoint = SubscriptionGatewayStages[ENV]

const VehicleGuidanceMessagingStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}/api/vehicle-guidance-messaging`,
  [Environment.local]: `http://localhost:${mockServerPort}/api/vehicle-guidance-messaging`,
  [Environment.development]:
    'https://vehicle-guidance-messaging-2.api.trip.dev.moia-group.io',
  [Environment.integration]:
    'https://vehicle-guidance-messaging-2.api.trip.int.moia-group.io',
  [Environment.production]:
    'https://vehicle-guidance-messaging-2.api.trip.prd.moia-group.io',
}

const SciReportingStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}/api/sci-reporting`,
  [Environment.local]: `http://localhost:${mockServerPort}/api/sci-reporting`,
  [Environment.development]:
    'https://reporting.sci-reporting.dev.moia-group.io',
  [Environment.integration]:
    'https://reporting.sci-reporting.int.moia-group.io',
  [Environment.production]: 'https://reporting.sci-reporting.prd.moia-group.io',
}

const SciDsBossStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}`,
  [Environment.local]: `http://localhost:8000`,
  [Environment.development]:
    'https://sci-api-ds-boss.sci-reporting.dev.moia-group.io',
  [Environment.integration]:
    'https://sci-api-ds-boss.sci-reporting.int.moia-group.io',
  [Environment.production]:
    'https://sci-api-ds-boss.sci-reporting.prd.moia-group.io',
}

const SciInsightsApiStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}`,
  [Environment.local]: `http://localhost:8000`,
  [Environment.development]:
    'https://sci-api-insights.sci-reporting.dev.moia-group.io',
  [Environment.integration]:
    'https://sci-api-insights.sci-reporting.int.moia-group.io',
  [Environment.production]:
    'https://sci-api-insights.sci-reporting.prd.moia-group.io',
}

const SciAIStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}`,
  [Environment.local]: 'http://localhost:8000',
  [Environment.development]:
    'https://sci-api-analysis.sci-reporting.dev.moia-group.io',
  [Environment.integration]:
    'https://sci-api-analysis.sci-reporting.int.moia-group.io',
  [Environment.production]:
    'https://sci-api-analysis.sci-reporting.prd.moia-group.io',
}

export const Endpoints = {
  VehicleGuidanceMessaging: {
    BroadcastMessage: `${VehicleGuidanceMessagingStages[ENV]}/publish-message`,
    VehicleMessage: `${VehicleGuidanceMessagingStages[ENV]}/publish-individual-message`,
  },
  SciReporting: {
    Rest: `${SciReportingStages[ENV]}/rest`,
    DsBoss: `${SciDsBossStages[ENV]}/ds-boss`,
    InsightsApi: `${SciInsightsApiStages[ENV]}/insights`,
    AI: `${SciAIStages[ENV]}/analysis`,
  },
}
